import { render, staticRenderFns } from "./EggDetail.vue?vue&type=template&id=13070309&scoped=true"
import script from "./EggDetail.vue?vue&type=script&lang=js"
export * from "./EggDetail.vue?vue&type=script&lang=js"
import style0 from "./EggDetail.vue?vue&type=style&index=0&id=13070309&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13070309",
  null
  
)

export default component.exports